import { valueStoreFactory } from 'services/utils/valueStoreFactory';

export const agentNameValueStore = valueStoreFactory();
